import { Box, Divider, LinearProgress, Stack, Typography, Grid, Paper, Icon } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateWatchlist } from "../redux/reducers/userSlice";
import userServices from "../services/userServices";
import { calcTarget, calculatePercent, convertToIndianFormat, isInWatchlist, roundPropertyPercentDisplay } from "../utils/functions";
import CustomIcon from "./customIcon";
import ShareIcon from '@mui/icons-material/Share';
import DomainIcon from '@mui/icons-material/Domain';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { calculateFraxValue, calculateTotalCost, calculateTotalRetailCost } from "../utils/transactionCalculationFunction";
import logsService from "../services/logServices";
import { InvestorActivityEventType } from "../utils/eventTypes";
export default function PropertyCard({ data, url }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { watchlist } = useSelector(state => state.user);
    const [inWatchlist, setInWatchlist] = useState(false);
    const [ratePerFrax, setRatePerFrax] = useState(0);
    const [retailRatePerFrax, setRetailRatePerFrax] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [totalRetailCost, setTotalRetailCost] = useState(0);
    const [noOfFrax, setNoOfFrax] = useState(0);
    const [noOfRemFrax, setNoOfRemFrax] = useState(0);
    const [target, setTarget] = useState(0);
    const [selectPropertyLaebl, shwoSelectPropertyLabel] = useState(false);
    const [actualRPF, setActualRPF] = useState(0);
    const [propertyLocation, setPropertyLocation] = useState("");
    const user = useSelector(state => state.user.data)



    const handleCardClick = () => {
        navigate(`/dashboard/property/${data?._id}`, { state: { id: data?._id } })
        logsService.addLog({
            userId: user?._id,
            event: InvestorActivityEventType.ASSET_VISITED,
            listingId: data?._id
        })
    }
    useEffect(() => {
        if (data) {
            const tempTotalRetailCost = Math.round(Number(calculateTotalRetailCost(data, data?.assetClass?.fields)) || 0);
            const tempTotalCost = Math.round(Number(calculateTotalCost(data, data?.transactionDetails?.leadSalePricePSF, data?.assetClass?.fields)) || 0);
            setInWatchlist(isInWatchlist(data?._id));
            setNoOfFrax(data?.numberOfFracs);
            setNoOfRemFrax(data?.remainingFracs);
            setTotalCost(tempTotalCost);
            setTotalRetailCost(tempTotalRetailCost);
            setRatePerFrax(calculateFraxValue(tempTotalCost, data))
            setRetailRatePerFrax(calculateFraxValue(tempTotalRetailCost, data))

            shwoSelectPropertyLabel(data?.membertype === "SELECT" ? true : false);
            setPropertyLocation(data?.project?.location?.city);

        }
    }, [data, watchlist])



    const getTitle = () => {
        if (data?.propertyType === "Residential") return `${data?.basicInfo?.flatNo}, Wing-${data?.basicInfo?.wing} in ${data?.project?.projectName} - ${data?.project?.location?.city}`
        if (data?.propertyType === "Commercial" || data?.propertyType === "Retail") return `${data?.basicInfo?.unitNo}, Wing-${data?.basicInfo?.wing} in ${data?.project?.projectName} - ${data?.project?.location?.city}`
        if (data?.propertyType === "Land") return `Plot No. ${data?.basicInfo?.plotNo} in ${data?.project?.projectName} - ${data?.project?.location?.city}`
        if (data?.propertyType === "Warehouse") return `Warehouse No. ${data?.basicInfo?.warehouseNo} in ${data?.project?.projectName} - ${data?.project?.location?.city}`
        if (data?.propertyType === "Asset") return `${data?.basicInfo?.assetName}`
        return "";
    }

    const getDescription = () => {
        //  return `${data?.propertyType}, ${data?.tenancyType} data.propertyStage.constructedWithOC? 'Constructed With OC': ''`}
        // return `${data?.propertyType}, ${data?.tenancyType}, ${data?.propertyStage?.constructedWithOC ? 'Constructed With OC' : ''}`;
        return `${data?.propertyType}, ${data?.tenancyType || ""} ${data?.propertyType === 'Asset'
            ? ''
            : data?.propertyType === 'Land'
                ? data?.propertyStage?.constructedWithOC
                    ? 'Plotted'
                    : 'Not Plotted'
                : data?.propertyStage?.constructedWithOC
                    ? 'Constructed With OC'
                    : 'Under Construction'
            }`;


    }

    const toggleWatchlist = async () => {
        const res = await userServices.toggleWatchlist(data?._id);
        if (res && res.success) {
            getMyWatchlist();
        }
    }

    const getMyWatchlist = async () => {
        const res = await userServices.getMyWatchlist();
        if (res && res.success && res.data?.length > 0) {
            console.log(" updating");
            enqueueSnackbar(inWatchlist ? "Removed from watchlist" : "Added in watchlist", { variant: "success" })
            dispatch(updateWatchlist(res.data));
        }
        else {
            enqueueSnackbar(inWatchlist ? "Removed from watchlist" : "Added in watchlist", { variant: "success" })
            dispatch(updateWatchlist([]));
        }
    }

    useEffect(() => {
        let temp = calcTarget(noOfFrax, noOfRemFrax, retailRatePerFrax);
        if (temp != null) setTarget(temp)
    }, [noOfFrax, noOfRemFrax, retailRatePerFrax])

    const Tdata = [
        { icon: 'DomainIcon', text: 'Time', value: '10:00 AM' },
        { icon: 'attach_money', text: 'Price', value: '$100' },
        { icon: 'people', text: 'Guests', value: '4' },
        { icon: 'check_circle', text: 'Status', value: 'Confirmed' },
        // Add more data objects for the second row
    ];
    const anualYield = (data?.tenancyDetails?.rentPerMonth * 12) / data?.transactionDetails?.salePrice;

    function onError(e) {
        e.target.src =
            "assets/icons/poweredby.png";
    }
    return (
        <Stack
            sx={{
                borderRadius: "10px",
                width: { md: 398, xs: "auto" },
                maxWidth: '100%',
                height: { md: 636, xs: 500 },
                cursor: "pointer"
            }}
            className="property-card"
            onClick={handleCardClick}
        >
            <Box
                sx={{
                    width: "100%",
                    height: "49.845%",
                    bgcolor: "purple",
                    borderRadius: "10px 10px 0px 0px",
                    // background:"url('https://images.pexels.com/photos/290275/pexels-photo-290275.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1')",
                    background: `url('${url}${data?.listingImages[0]?.docUrl}')`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    position: "relative",
                }}
            >


                <Grid style={{
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    zIndex: '1',
                    display: selectPropertyLaebl ? 'block' : 'none'
                }}>
                    <img src="/assets/images/select_banner.png" style={{ height: "109px", width: '115px' }} alt="Description of the image" />
                </Grid>

                <Stack
                    direction={"column"}
                    justifyContent={"space-between"}
                    sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        // background: "transparent linear-gradient(180deg, #0000001A 0%, #141E37CC 100%) 0% 0% no-repeat padding-box",
                        borderRadius: "10px 10px 0px 0px",
                        px: { md: 2, xs: 2 },
                        pt: { md: 2, xs: 3 },
                        pb: { md: 2, xs: 3 },
                    }}
                >
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={'center'}>
                        {data?.status !== "COMPLETED" && <Box
                            sx={{
                                background: "#ffffffcc",
                                color: '#000000a3',
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: '75%',
                                padding: '0px 6px',
                                borderRadius: '5px',
                            }}
                        >
                            <FmdGoodIcon sx={{ fill: '#ea4335', width: '18px', height: '18px' }} />
                            <Typography variant="miscTab" sx={{ fontWeight: 600 }}>{propertyLocation}</Typography>
                        </Box>}

                        {data?.status == "COMPLETED" && <Box sx={{
                            backgroundColor: "#4a4ad5",
                            padding: "4px 20px 4px 8px",
                            borderRadius: "8px",
                            width: "fit-content",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            clipPath: "polygon(0% 0, 85% 0, 100% 100%, 0% 100%)",
                            justifyContent: "flex-start",
                            position:"absolute",
                            top: "8px",
                            left: "8px"
                        }}>
                            <Typography variant="body2" sx={{ color: "#FFF", fontWeight: 500, letterSpacing: "0.5px" }}>Completed</Typography>
                        </Box>}

                        {data?.status !== "COMPLETED" && <Box
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                toggleWatchlist();
                            }}
                            sx={{
                                borderRadius: "100%",
                                // background:"#ffffff33 0% 0% no-repeat padding-box",
                                width: 36,
                                height: 36,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: 0.5,
                                position: "relative",
                                background: inWatchlist ? "white" : "inherit",
                                overflow: "hidden",
                                "&::before": {
                                    content: inWatchlist ? null : "''",
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "18px",
                                    background: "inherit",
                                    boxShadow: "inset 0 0 0 200px rgb(255,255,255)",
                                    filter: "blur(50px) brightness(12%)",
                                    zIndex: 0
                                }
                            }}
                        >
                            <CustomIcon name={inWatchlist ? "heart-filled" : "heart"} sx={{ bgcolor: inWatchlist ? "#ff3d6b" : "#FFF" }} />
                        </Box>
                        }
                    </Stack>
                </Stack>
            </Box>
            <Stack direction={"column"} className="property-card-wrapper"
                sx={{
                    px: { md: 2, xs: 2 },
                    pt: { md: 1, xs: 2 },
                    pb: 1,
                    flex: 1,
                    borderRadius: "0px 0px 10px 10px",
                    border: "1px solid",
                    borderColor: "divider"
                }}
            >
                {/* <Box
                        sx={{
                            borderRadius:"18px",
                            bgcolor:"primary.main",
                            padding:"8px 24px",
                            display:"flex",
                            justifyContent:"center",
                            alignItems:"center",
                            color:"#FFF",
                            width:"fit-content",
                            
                        }}
                    >
                        <Typography variant="chipText" sx={{color:"#FFF"}}>{data?.propertyType}</Typography>
                    </Box> */}
                <Grid container spacing={2}>

                    <Grid item xs={4}>
                        <div style={{ textAlign: 'center' }}>
                            <img src="assets/icons/builder.png" alt="Image 1" style={{
                                width: 'auto',
                                height: '2.5rem',
                                minHeight: '2.5rem',
                                maxHeight: '2.5rem',
                                maxWidth: '100%',
                                overflow: 'hidden',
                                display: 'block',
                                margin: 'auto',
                                marginBottom: '5px',
                            }}
                            />
                            <Typography variant="subtitle1">Developer</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={4} style={{ zIndex: '20' }}>

                        {data?.isBranded &&
                            <div style={{ textAlign: 'center' }}>
                                <img
                                    src={`${url}${data?.created_by?.logo}`}
                                    onError={(e) => onError(e)}
                                    lt="Image 1"
                                    style=
                                    {{
                                        width: '5.5rem',
                                        height: '5.5rem',
                                        minHeight: '5.5rem',
                                        maxHeight: '5.5rem',
                                        maxWidth: '5.5rem',
                                        overflow: 'hidden',
                                        display: 'block',
                                        margin: 'auto',
                                        borderRadius: '50%',
                                        backgroundColor: 'white',
                                        marginTop: "-55px",
                                        marginBottom: '5px'
                                    }}
                                />
                                <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "#333" }}>{(data?.created_by?.name?.slice(0, 1)?.toUpperCase() + data?.created_by?.name?.slice(1, data?.created_by?.name?.length)?.toLowerCase()) || ""}</Typography>
                                <Typography variant="subtitle1">Deal Manager</Typography>
                            </div>
                        }
                    </Grid>

                    <Grid item xs={4}>
                        <div style={{ textAlign: 'center' }}>
                            <img src="assets/icons/tenant.png" alt="Image 1" style={{
                                width: 'auto',
                                height: '2.5rem',
                                maxHeight: '2.5rem',
                                minHeight: '2.5rem',
                                maxWidth: '100%',
                                overflow: 'hidden',
                                display: 'block',
                                margin: 'auto',
                                marginBottom: '5px',
                            }} />
                            <Typography variant="subtitle1">Tenant</Typography>
                        </div>
                    </Grid>
                </Grid>



                <Typography noWrap sx={{ fontSize: 22, fontWeight: 500, mt: 1, textOverflow: "ellipsis", wordBreak: "break-word", textWrap: "wrap" }}>{getTitle()}</Typography>
                <Typography variant="body2" sx={{ color: '#333333' }}>{getDescription()}</Typography>

                <Grid container spacing={0.5} sx={{ my: 1 }}>

                    <Grid xs={6} sx={{ textAlign: "left" }}>
                        <Typography variant="subtitle1">SELLING PRICE PER {data?.assetClass?.tokenName ? data?.assetClass?.tokenName?.toUpperCase() : "FRAX"}</Typography>

                        <Typography variant="h4" sx={{ color: '#333333' }}>
                            {convertToIndianFormat(Number((ratePerFrax)?.toFixed(2)))}
                            <span style={{ fontSize: '0.75rem', marginLeft: '4px' }}></span>
                        </Typography>
                    </Grid>

                    <Grid xs={6} sx={{ textAlign: "right" }}>
                        <Typography variant="subtitle1">Selling Price per {data?.assetClass?.assetUnit ? data?.assetClass?.assetUnit?.toUpperCase() : "SQFT"} </Typography>
                        <Typography variant="h4" sx={{ color: '#333333' }}>
                            {convertToIndianFormat(Number((ratePerFrax * (data?.assetClass?.tokenMultiplier || 144))?.toFixed(0))) || "-"}
                            <span style={{ fontSize: '0.75rem', marginLeft: '4px' }}></span>
                        </Typography>
                    </Grid>
                </Grid>




                {/* <Divider sx={{my:{md:3,xs:2}, marginTop: '14px', marginBottom: '14px'}} /> */}

                {/* <div>
                      {data?.highlights.map((item, index) => (<div key={index} dangerouslySetInnerHTML={{ __html: item.highlightValue }}/>)}
                    </div> */}


                <Grid container spacing={2} sx={{ my: 1 }} className="property-characteristics">

                    <Grid xs={4} sx={{ textAlign: "center" }}>
                        <DomainIcon color="action" fontSize="small" />
                        <Typography variant="subtitle1">{`Total ${data?.assetClass?.assetUnit ? data?.assetClass?.assetUnit : "BuiltUp Area"}`}</Typography>
                        <Typography variant="body2">{convertToIndianFormat(data?.characteristics?.builtupArea || data?.characteristics?.tokenCalculationBase, false)} {data?.assetClass?.assetUnit ? data?.assetClass?.assetUnit?.toLowerCase() : "sqft"}</Typography>
                    </Grid>

                    {data.tenancyType !== "Vacant" && data.propertyType !== "Asset" ? (
                        <Grid xs={4} sx={{ textAlign: "center" }}>
                            <HomeWorkRoundedIcon color="action" fontSize="small" />
                            <Typography variant="subtitle1">Rental Yield</Typography>
                            <Typography variant="body2">{anualYield.toFixed(2)} %</Typography>
                        </Grid>
                    ) : (

                        <Grid xs={4} sx={{ textAlign: "center" }}>
                            <HomeWorkRoundedIcon color="action" fontSize="small" />
                            {/* <Typography variant="subtitle1">Carpet Area</Typography> */}
                            <Typography variant="subtitle1">Total {data?.assetClass?.tokenName ? data?.assetClass?.tokenName?.toUpperCase() : "FRAX"}</Typography>
                            <Typography variant="body2">{convertToIndianFormat(data?.numberOfFracs, false)}</Typography>
                            {/* <Typography variant="body2">{data?.characteristics?.carpetArea} sqft</Typography> */}
                        </Grid>
                    )}

                    {/* Sales Price icon and info -  Keeping commened for future use*/}
                    {/* <Grid xs={3} sx={{textAlign: "center"}}>
                    <GridViewOutlinedIcon color="action" fontSize="small"/>
                        <Typography variant="subtitle1">Selling Price</Typography>
                            <Typography variant="body2">
                            ₹ {data?.transactionDetails?.salePricePSF.toFixed(0)}
                                </Typography>
                    </Grid> */}
                    <Grid xs={4} sx={{ textAlign: "center" }}>
                        <CurrencyRupeeRoundedIcon color="action" fontSize="small" />
                        <Typography variant="subtitle1">Min Investment</Typography>
                        <Typography variant="body2">{convertToIndianFormat(Number(data?.transactionDetails?.minInvestmentAmount?.toFixed(0)))}</Typography>
                    </Grid>




                </Grid>


                <Grid>

                    <Stack direction={"column"} spacing={2} sx={{ marginTop: 1 }}>
                        {/* <Stack direction={"row"} justifyContent={"space-between"}>
                            <Typography sx={{fontSize:16,fontWeight:400}}>Min Investment</Typography>
                            <Typography sx={{fontSize:16,fontWeight:500}}>{(data?.transactionDetails?.minInvestmentAmount)?.toLocaleString('en-IN')}</Typography>
                        </Stack> */}
                        <Stack direction={"row"} justifyContent={"space-between"}>
                            <Typography variant="body2">Invested</Typography>
                            <Typography >{roundPropertyPercentDisplay(calculatePercent(target,totalRetailCost))}%</Typography>
                        </Stack>
                    </Stack>
                    <LinearProgress
                        variant="determinate"
                        value={calculatePercent(target, totalRetailCost) || 0}
                        sx={{
                            mt: 1,
                            height: 8,
                            borderRadius: 5,
                            backgroundColor: "#e0e0e0",
                            "& .MuiLinearProgress-bar": {
                                backgroundColor: "#2ECC71" // Material UI green[600]
                            }
                        }}
                    />
                    <Typography variant="subtitle1" sx={{ fontSize: 14, fontWeight: 400, mt: { md: 2, xs: 1.5 } }}>{convertToIndianFormat(target) || 0} / {convertToIndianFormat(totalRetailCost)}</Typography>

                </Grid>



            </Stack>


        </Stack>
    )
}